import { render } from "./CheckoutProducts.vue?vue&type=template&id=9d43fe54"
import script from "./CheckoutProducts.vue?vue&type=script&lang=js"
export * from "./CheckoutProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__